__turbopack_context__.v({
  "actions": "filters-module-scss-module__NjF8aG__actions",
  "filterGroup": "filters-module-scss-module__NjF8aG__filterGroup",
  "filters": "filters-module-scss-module__NjF8aG__filters",
  "resetBtn": "filters-module-scss-module__NjF8aG__resetBtn",
  "showResults": "filters-module-scss-module__NjF8aG__showResults",
});
